import { createFileRoute } from "@tanstack/react-router";

import { WalletHistoryPage } from "@/features/my/settings/account/billing/wallet/wallet-history/wallet-history-page";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/billing/wallet/history",
)({
  component: WalletHistoryPage,
});
